import { API_URL } from '../../actions/settings';
import NotificationPopUp from './NotificationPopUp';
import { UnexpectedError } from '../../pages/Errors/Errors';

async function getSoftwareUploadURL(token:any,data:any) {

  return fetch(`${API_URL}/s3/upload/software`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':token
    },
    body: JSON.stringify(data),

  })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        throw new UnexpectedError();
      }
    })
    .catch((error) => {
      NotificationPopUp(
        "error",
        "Could not generate upload url",
        "Upload Error",
        1200
      );
      return null;
    });
 }

async function uploadSoftware(url:any,file:any,contentType:any) {

  return fetch(`${url}`, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,      
    },
    body: file,

  })
    .then((res) => {
      if (res.status === 200) {
        return res;
      } else {
        throw new UnexpectedError();
      }
    })
    .catch((error) => {
      console.log(error)      
      console.log('Could not upload to s3 bucket')
      NotificationPopUp(
        "error",
        "Could not Upload Software",
        "Upload Error",
        1200
      );
      return null;
    });
 }



async function AE2SoftwareUpload(bucket_name:string,filename:string,file:any,contentType:any) {

    const data = {
      "bucket": bucket_name || '',
      "filename": filename,
      "content_type": contentType
    };

    try{
        // const res = await bucket.getSignedUrlPromise(GetObjectCommand,params)
        const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
        const url = await getSoftwareUploadURL(token,data)
        if(url){
        const res = await uploadSoftware(url['presigned_url'],file,data['content_type'])
        if(res){
          return true
        }
        }
        return false
    }catch (error){
        console.log(error)
        return false
    }

}

export default AE2SoftwareUpload